import React, { type SyntheticEvent } from "react";
import FocusTrap from "focus-trap-react";
import { BnbLabel } from "../../../../utils/labels";
import * as Flex from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as BasketStyles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import * as Styles from "../nav/styles/BasketButton";
import Basket from "./Basket";
import BasketHeader from "./content/BasketHeader";
import BasketFinanceTogglePanel from "../basket-financetoggle-panel/BasketFinanceTogglePanel";
import { useDisableBodyScroll } from "../../../../../../../common-deprecated/hooks";
import { MAIN_NAV_CLASSNAME_TOYOTA } from "../../../../../../../common-deprecated/constants";
import { showMobileBasket } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import UnsetZIndexHelper from "../../../../../../../common-deprecated/components/UnsetZIndexHelper";
import { SrOnly } from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

const MobileBasket = (): JSX.Element => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const step = useBnbSelector((state) => state.navigation.step);
    const car = useBnbSelector((state) => state.car);
    const isFocusTrapEnabled = !useBnbSelector((state) => state.modal.modals.some(({ show }) => show));

    useDisableBodyScroll();

    const closeBasket = (event: SyntheticEvent): void => {
        event.preventDefault();
        dispatch(showMobileBasket(false));
    };

    return (
        <FocusTrap
            focusTrapOptions={{
                tabbableOptions: { getShadowRoot: () => false },
                allowOutsideClick: true,
            }}
            active={isFocusTrapEnabled}
        >
            <Styles.MobileBasket>
                {/* component only renders when it is actually visible (for performance reasons), so no disabled flag is needed */}
                <UnsetZIndexHelper enabled selectors={[MAIN_NAV_CLASSNAME_TOYOTA]} />
                <div className="or-scroll-target payment-switch" />
                <Styles.MobileBasketHeader>
                    <Styles.BasketTitle data-cpdqm="ignore">
                        <BnbLabel label="basketYourModel" params={{ name: car.model.webtitleSectionName }} />
                    </Styles.BasketTitle>

                    <Styles.CloseMobileBasket type="button" onClick={closeBasket}>
                        <Icon variant="close" />
                        <SrOnly>
                            <BnbLabel label="bnbA11yButtonBasketClose" />
                        </SrOnly>
                    </Styles.CloseMobileBasket>
                </Styles.MobileBasketHeader>

                {step === NavStep.Summary && (
                    <Styles.MobileHeaderWrapper>
                        <Flex.Col mt={{ _: 0, lg: 3 }} px={0}>
                            <BasketHeader />
                        </Flex.Col>
                    </Styles.MobileHeaderWrapper>
                )}

                <BasketStyles.BasketHeader>
                    <BasketFinanceTogglePanel />
                </BasketStyles.BasketHeader>

                <Basket attached={step === NavStep.Customize} />
            </Styles.MobileBasket>
        </FocusTrap>
    );
};

export default MobileBasket;
